import * as React from "react"

const H4 = ({ className, children }) => (
  <h4 className={`text-lg lg:text-xl italic font-body ${className}`}>
    {children}
  </h4>
)

export default H4
